<template>
<div class="d-flex justify-end align-center">
    <v-tooltip bottom :disabled="item.payment&&!(!item.payment.type||(item.payment.viewed > 2))">
        <template v-slot:activator="{ on }">
            <div v-on="on">
                <v-btn class="mx-1" :small="$vuetify.breakpoint.smAndDown" color="primary" :disabled="!item.payment||!item.payment.type||(item.payment.viewed > 2)" @click="openModalCC()">
                    <span v-if="item.payment&&item.payment.type">credit card</span>
                    <span v-else>NO CC info</span>
                </v-btn>
            </div>
        </template>
        <span v-if="item.payment&&item.payment.type">A fost atins numarul maxim de vizualizari</span>
        <span v-else>Fara detaliile cardului</span>
    </v-tooltip>
    <v-btn v-if="item.channel != 'Booking'" :small="$vuetify.breakpoint.smAndDown" class="text-capitalize mx-1" text @click="openModalInvoice()">
        <span>{{ $t('dashboard.reservations.modal.show_invoice') }}</span>
    </v-btn>
</div>
</template>

<script>
import defaults from "../../../utils/PropDefaults.js";
import IMPrice from '../../../small-components/IMPrice.vue';

export default {
    components: {},

    props: {
        item: {
            type: Object,
            default: function () {
                return defaults.reservation_item
            }
        },
    },
    data() {
        return {}
    },
    methods: {

        openModalCC() {
            this.$emit('openModalCC')
        },
        openModalInvoice() {
            this.$emit('openModalInvoice')
        }

    },
}
</script>
